import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { getEnterpriseServiceAccountsQueryKey } from 'hooks/queries/enterprise';

const apiFn = apiClient.enterprises.batchUpdateServiceAccounts;

type RequestParams = Parameters<
  typeof apiFn
>[0]['batchUpdateEnterpriseServiceAccountsRequest'];

export const useBatchUpdateEnterpriseServiceAccountsMutation = () => {
  const { enterpriseOrgId } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serviceAccountRequests: RequestParams['requests']) =>
      apiFn(
        {
          enterpriseId: enterpriseOrgId!,
          batchUpdateEnterpriseServiceAccountsRequest: {
            enterpriseId: enterpriseOrgId!,
            requests: serviceAccountRequests,
          },
        },
        {
          headers: overrideOrganizationHeader(enterpriseOrgId),
        }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEnterpriseServiceAccountsQueryKey({
          enterpriseOrgId: enterpriseOrgId!,
        }),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
